var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`text-${_vm.chipColor(_vm.params.value)}`},[_vm._v(_vm._s(_vm.colorText(_vm.params.value)))])
}
var staticRenderFns = []

export { render, staticRenderFns }